export default {
  product: {
    title: '製品',
    selfCustodyWallet: 'モバイルウォレット',
    selfCustodyWalletDesc: 'ブロックチェーンの暗号資産&DeFiモバイルウォレット',
    hardwareWallet: 'ハードウェアウォレット',
    hardwareWalletDesc: 'あなたの資産を守る、KeyPalをゲットしよう。',
    extensionWallet: '拡張ウォレット',
    extensionWalletDesc: 'デスクトップでより良いウォレットを。',
    transit: 'Transit',
    transitDesc: 'マルチチェーンのDEXアグリゲーター&NFTマーケットプレイス',
    fiveDegrees: '5Degrees',
    fiveDegreesDesc: 'Web3.0のソーシャルネットワークプロトコル',
  },
  project: {
    subDApp: 'DAppを投稿',
    subToken: 'トークンを投稿',
    subNFT: 'NFTを投稿',
    subChain: 'チェーン',
  },
  assets: {
    title: 'アセット',
  },
  collaborations: {
    title: 'コラボレーション',
  },
  community: {
    title: 'コミュニティ',
    developers: '開発者',
    recruiting: 'TPマン(採用)',
  },
  helpCenter: {
    title: 'ヘルプセンター',
  },
  features: {
    title: 'プロダクト',
    buyCrypto: '暗号資産を購入',
    mobileWallet: 'モバイルウォレット',
    hardwareWallet: 'ハードウェアウォレット',
    extensionWallet: '拡張ウォレット',
    desktop: 'デスクトップウォレット',
    fiveDegrees: '5Degrees',
    approvalDetector: 'アプルーバルディテクター',
    tokenSecurity: 'トークンセキュリティ',
    keyGenerator: 'キージェネレーター',
    BATCH_SENDER: 'バッチセンダー',
  },
  information: {
    title: '詳細',
    blockchainGuide: 'ブロックチェーンガイド',
    tronWallet: 'TRON Guide',
    iostWallet: 'IOST Guide',
    tpMan: 'TPマン',
  },
  developers: {
    title: '開発者',
    github: 'Github (TP-Lab)',
    devCenter: '開発者センター',
    subToken: 'トークンを投稿',
    subDApp: 'DAppを投稿',
    subNFT: 'NFTを投稿',
  },
  company: {
    title: '会社',
    about: 'TokenPocketについて',
    careers: 'キャリア',
    pressKit: 'プレスキット',
    swagShop: 'スワッグショップ',
  },
  support: {
    title: 'サポート',
    helpCenter: 'ヘルプセンター',
    contactUs: 'お問い合わせ',
  },
  legal: {
    title: '法的情報',
    privacyPolicy: 'プライバシーポリシー',
    terms: '利用規約',
  },
  main: {
    title: 'バージョンの確認',
    language: '日本語',
    intro:
      'バージョンの確認は、バージョン間のMD5またはSHA256ハッシュ値を照合することによって行われます。トークンポケットウォレットを公式チャンネルからダウンロードすることを確認して、騙されないようにしてください。バージョンのMD5またはSHA256ハッシュ値の取得方法についての手順は、 ',
    tutorial: 'チュートリアルを参照してください >',
    system: 'OS',
    android: 'Android',
    ios: 'iOS',
    version: 'バージョン',
    allVersion: '全て',
    appChannel: 'アプリチャンネル',
    developer: '開発者',
    allChannel: '全て',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'バージョンログ',
    check: '詳細',
    versionLog: 'バージョンログ',
    confirm: '確認',
    aboutIOS: 'iOSバージョンについて',
    IOSDesc:
      'iOSバージョンについては、当社のアプリはApp Storeでのみ提供されています。App Storeからダウンロードされたアプリのみが正しくインストールされます。したがって、Appleデバイスを使用する場合は、App Storeを唯一のダウンロードチャンネルとして認証してください。',
    IOSDesc_2:
      '2022年10月8日以前にApp Storeからダウンロードされたバージョンの開発者はTOKENPOCKET FOUNDATION LTDであり、TokenPocketによって開発された初期のバージョンです。正規のウォレットであり、通常使用することができますが、更新サービスは一時的に中断されます。',
    aboutAndroid: 'Android バージョンについて',
    androidDesc: '現在のTokenPocketのAndroidダウンロードチャネルには、公式ウェブサイト、Google Playストア、Samsungアプリストア、Huaweiアプリギャラリー、OPPOアプリストア、Vivoアプリストアが含まれています。一部のアプリストアでは、ダウンロード中にAPKインストールパッケージを取得できないため、MD5またはSHA256の計算検証を行うことができません。したがって、ダウンロードする際には、開発者情報を正確に確認し、以下を参照してください！',
    IOSAppName: 'アプリ名:',
    TPWallet: 'TPウォレット',
    AppIcon: 'アプリアイコン:',
    AppDeveloper: '開発者:',
    downloadLink: 'ダウンロードURL:',
    copied: 'コピーしました！',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'フォローする',
    desc1: 'TokenPocket スタッフからプライベート メッセージは送信されません!',
    desc2:
      '注意！ TokenPocket コミュニティに参加しようとしています。誰かが私たちになりすましてプライベート メッセージを送信している可能性があります。 プライベート メッセージを送信する人は詐欺師である可能性があることに注意してください。 最初に連絡することはありません！',
    desc3: '了解、入力',
  },
};
